import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { reducer as notifications } from 'react-notification-system-redux';
import { RouterState } from 'redux-first-history';

import { routerReducer } from './config/history';
import authReducer, { AuthState } from './auth/auth.reducer';
import uiReducer, { UIState } from './ui/ui.reducer';
import entitiesReducer, { EntitiesState } from './entities/entities.reducers';

export interface RootState {
  auth: AuthState;
  router: RouterState;
  form: any;
  ui: UIState;
  notifications: any;
  entities: EntitiesState;
}

const rootReducer = combineReducers<RootState>({
  auth: authReducer,
  router: routerReducer,
  form: formReducer,
  ui: uiReducer,
  notifications,
  entities: entitiesReducer,
});

export default rootReducer;
